import './styles/variables.css';
import './styles/common.css';
import './styles/preview.css';
import './styles/dashboard.css';
import './styles/share.css';
import { SharePage } from './ui/share/SharePage.js';

const sharePage = new SharePage();
sharePage.render(document.getElementById('share-app'));
